import axios from "axios"
import { customToast } from "../components/toast/custom-react-toastify/v1"

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST

export function CoupangApiApi(props) {
    return {
        searchCoupangApiStoreInfos: async ({ params, headers }) => {
            return await axios.get(`${MAIN_API_HOST}/coupang-api/coupang-api-store-infos`, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        addCoupangApiStoreInfos: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/coupang-api/coupang-api-store-infos`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        editCoupangApiStoreInfos: async ({ params, headers, body }) => {
            return await axios.put(`${MAIN_API_HOST}/coupang-api/coupang-api-store-infos`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        collectOrders: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/coupang-api/collect-orders`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        returnConfirmOrder: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/coupang-api/return-confirm-order/from-return-exchanges`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        return {
                            res: null,
                            message: '서버와의 연결이 원할하지 않습니다.'
                        }
                    }

                    let res = err.response;

                    return {
                        res: res,
                        message: res.data?.message
                    }
                })
        },
        exchangeConfirmOrder: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/coupang-api/exchange-confirm-order/from-return-exchanges`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        return {
                            res: null,
                            message: '서버와의 연결이 원할하지 않습니다.'
                        }
                    }

                    let res = err.response;

                    return {
                        res: res,
                        message: res.data?.message
                    }
                })
        }
    }
}